import React, { useEffect, useState } from 'react';
import { folderManagementServices } from '../../APIServices/folderManagementServices';
import { useToast } from '../../hooks/useToast';

function AddNewFolder({ getFolderManagementData, setModalOpen}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const addNewFolderManagement = async () => {
    setButtonLoader(true);
    try {
      let userData = {};
      userData.code = code;
      userData.name = name;
      userData.description = description;
      userData.type = "folder";
      let data = await folderManagementServices.addNewFolderManagement(userData);
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Folder added successfully.', 'ok');
        setCode("");
        setName("");
        setDescription("");
        getFolderManagementData();
        setModalOpen("");
      } else {
        toast(data?.customMessage || 'Unable to add folder.', 'warn');
      }
    } catch (error) {
      toast('Unable to add folder. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Add Folder
            </div>

            <div className="xs muted">
              Create a Folder for the document
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Folder Code
              <span className="req">
                *
              </span>
            </label>
            <input
              className="inp"
              disabled={buttonLoader}
              placeholder="e.g., CL-01"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">
              Folder Name
              <span className="req">
                *
              </span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader}
              placeholder="e.g., Clinical Lead"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="field">
            <label className="field-label">
              Description
            </label>
            <textarea
              className="ta"
              disabled={buttonLoader}
              placeholder="Brief description of this folder"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
            />
          </div>
        </div>

        <div className="modal-foot">
          <button
            className="btn btn-ghost"
            onClick={() =>
              setModalOpen("")
            }
          >
            Cancel
          </button>
          <button
            className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
            onClick={() => addNewFolderManagement()}
            disabled={buttonLoader || !code || !name}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Adding...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Add Folder</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNewFolder;
